import React, { useState } from 'react';
import { BookOpen, Tag, ChevronDown, ChevronUp } from 'lucide-react';

interface QuestionDetailsCardProps {
  topic: string;
  subtopic: string;
  questionExplanation: string;
  showBadges?: boolean;
  showAbout?: boolean;
}

export const QuestionDetailsCard: React.FC<QuestionDetailsCardProps> = ({
  topic,
  subtopic,
  questionExplanation,
  showBadges = true,
  showAbout = true,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const hasBadges = !!(topic || subtopic);
  const hasAbout = !!questionExplanation;
  const hasContent = (showBadges && hasBadges) || (showAbout && hasAbout);
  if (!hasContent) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      {/* Header with Topic/Subtopic badges */}
      {showBadges && hasBadges && (
        <div className="px-4 py-3 border-b border-gray-100">
          <div className="flex items-center gap-2 flex-wrap">
            {topic && (
              <span
                className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700"
              >
                <BookOpen className="w-3 h-3" />
                {topic}
              </span>
            )}
            {subtopic && (
              <span
                className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700"
              >
                <Tag className="w-3 h-3" />
                {subtopic}
              </span>
            )}
          </div>
        </div>
      )}

      {/* Question Explanation - collapsible */}
      {showAbout && hasAbout && (
        <div className="px-4 py-3">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-full flex items-center justify-between text-left"
          >
            <span className="text-sm font-medium text-gray-700">About this question</span>
            {isExpanded ? (
              <ChevronUp className="w-4 h-4 text-gray-400" />
            ) : (
              <ChevronDown className="w-4 h-4 text-gray-400" />
            )}
          </button>
          {isExpanded && (
            <div className="mt-2 max-h-32 overflow-y-auto pr-2">
              <p className="text-sm text-gray-600 leading-relaxed">
                {questionExplanation}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default QuestionDetailsCard;
